import { getPerformanceNowTimeSec } from '../../../common/utils';

import { IMicrofrontendState } from '../../types/reducers/microfrontend';

export const defaultState: IMicrofrontendState = {
  initLoadTime: getPerformanceNowTimeSec(),
  hostName: null,
};
